import { BlocksIconFileUpload } from 'blocks-nextjs/blocks-web-components/components/icon/icons/file-upload';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconFileUpload = createComponent({ react: React, tagName: 'cat-icon-file-upload', elementClass: BlocksIconFileUpload });
